// vite-env.d.ts
// env.d.ts
/// <reference types="vite-plugin-pages/client-react" />

import "@fontsource/inter";
import "./styles/rsuite-customized.less";
import "./styles/base.css";
import "./styles/swal2-customizations.css";
import "./styles/apexcharts-customizations.css";

import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import "./setup/reporting";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <Router>
        <StrictMode>
            <App />
        </StrictMode>
    </Router>,
);
